import React, { useEffect, useState } from "react";
import EwalletService from "../../../service/ewallet/Ewallet";
import Table from "react-bootstrap/Table";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { formatNumberWithCommasAndDecimal } from "../../helper";

//service
import AppInfoservice from "../../../service/common/Appinfo";

//style
import { Row, Col } from "react-bootstrap";
import PayoutService from "../../../service/payout";

export class ComponentToPrint extends React.PureComponent {
  constructor(props) {
    super(props);
    console.log("------------------------payoutreportff", props);
    this.service = new PayoutService();
    const current = new Date();
    const startD = props.filter.start;
    const endDa = props.filter.end;
    const date = `${current.getDate()}/${
      current.getMonth() + 1
    }/${current.getFullYear()} , ${current.getHours()}:${current.getMinutes()}`;
    // const time = current.getHours() + ':' + current.getMinutes();

    this.state = {
      earnings: {},
      loading: true,
      startD,
      endDa,
      date: date,
    };
    console.log("earnings==========", this.props);
  }

  exportDatas(type) {
    console.log("entering here=====", type);
    // let keys = this.props.filter
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");
    console.log(this.state, "export in payout data");
    this.service
      .exportData(
        0,
        100,
        this.state.startD,
        this.state.endDa
        // this.state.filter.start,
        // this.state.filter.end,
      )
      .then((res) => {
        if (res.status) {
          console.log("user print view", res);
          this.setState((prevState) => ({
            ...prevState,
            loading: false,
            earnings: res.data.table_data,
          }));
          console.log("earnings===ddd", this.state.earnings);
        } else {
          this.setState((prevState) => ({
            ...prevState,
            loading: true,
          }));
        }
      });
  }

  // componentDidUpdate(prevProps) {
  //   if (
  //     // this.props.data.filterValues != prevProps.data.filterValues ||
  //     this.props.data.startDate != prevProps.data.startDate ||
  //     this.props.data.endDate != prevProps.data.endDate
  //   ) {
  //     this.exportDatas("print");
  //   }
  // }
  componentDidMount() {
    this.exportDatas("print");
  }

  render() {
    return (
      <div style={{ padding: 60 }}>
        <Row>
          <Col>{this.state.date}</Col>
          <Col>
            <h5 style={{ textAlign: "center" }}>Encashment History</h5>
          </Col>
        </Row>

        <div ref={this.ref}>
          <Row style={{ marginBottom: 50 }}>
            <Col span={8}>
              <img
                src={this.props.company.logo}
                alt="Logo"
                style={{ width: "10%" }}
              />
              <div>COMPANY NAME : {this.props.company.comapny_name}</div>
              <div>COMPANY ADDRESS : {this.props.company.company_address}</div>
              <div>TELEPHONE : {this.props.company.phone}</div>
              <div>EMAIL : {this.props.company.email}</div>
              {console.log("printview ", this.state.earnings)}
            </Col>
          </Row>

          {!this.state.loading && this.state.earnings.length > 0 && (
            <Table striped hover>
              <thead>
                <tr>
                  <th>Requested Date</th>
                  <th>Reference Number</th>
                  {/* <th>{this.props.t("Common.totalAmount")}</th>
                   */}
                  <th>Amount</th>
                  <th>Processing Fee</th>
                  <th>W/TAX</th>
                  <th>Net Amount</th>
                  <th>Type</th>
                  <th>Release Method</th>
                  <th>Status</th>
                  <th>Released Date</th>
                </tr>
              </thead>
              <tbody>
                {this.props?.data?.map((obj, index) => {
                  console.log("dataa===========", obj);
                  return (
                    <tr key={index}>
                      <td>
                        {moment(obj.requested_date).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                      </td>
                      <td>{obj.reference_number}</td>
                      <td>
                        {this.props.Currency.currentCurr}
                        {formatNumberWithCommasAndDecimal(
                          obj.amount * this.props.Currency.value,
                          this.props.Currency.precision
                        )}
                      </td>
                      <td>
                        {this.props.Currency.currentCurr}
                        {formatNumberWithCommasAndDecimal(
                          obj.processingFee * this.props.Currency.value,
                          this.props.Currency.precision
                        )}
                      </td>
                      <td>
                        {this.props.Currency.currentCurr}
                        {formatNumberWithCommasAndDecimal(
                          obj.tax * this.props.Currency.value,
                          this.props.Currency.precision
                        )}
                      </td>
                      <td>
                        {this.props.Currency.currentCurr}
                        {formatNumberWithCommasAndDecimal(
                          obj.net_amount * this.props.Currency.value,
                          this.props.Currency.precision
                        )}
                      </td>
                      <td>{this.props.t(`payout.${obj.release_method}`)}</td>
                      <td>{obj.release_method}</td>
                      <td>{obj.status}</td>
                      <td>
                        {obj.released_date != ""
                          ? moment(obj.released_date).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    );
  }
}

const PurchaseReportPrintView = React.forwardRef((props, ref) => {
  const Currency = useSelector((state) => state.curr);
  const { t } = useTranslation();
  console.log("printdata===ddd", props);
  console.log(" ==== props value on click ==== ", JSON.stringify(props.state));
  const [companyDetails, setCompanyDetails] = useState({});

  const service = new AppInfoservice();

  useEffect(() => {
    service.Appinfo().then((res) => {
      if (res.status) {
        setCompanyDetails((prevState) => ({
          ...prevState,
          logo: res.data.company_info.login_logo,
          comapny_name: res.data.company_info.company_name,
          company_address: res.data.company_info.company_address,
          phone: res.data.company_info.phone,
          email: res.data.company_info.email,
        }));
      }
    });
  }, []);
  return (
    <ComponentToPrint
      ref={ref}
      {...props}
      data={props.ContentData}
      company={companyDetails}
      Currency={Currency}
      t={t}
    />
  );
});
export default PurchaseReportPrintView;
